import { Languages } from 'lucide-react'
import { useLocale } from '../i18n/locale'
import { useT } from '../i18n/t'

type Props = {
  className?: string
  size?: 'sm' | 'md'
}

export function LocaleSwitch({ className, size = 'sm' }: Props) {
  const { locale, setLocale } = useLocale()
  const { t } = useT()

  const label = locale === 'cs' ? 'CS' : 'PL'
  const next = locale === 'cs' ? 'pl' : 'cs'

  return (
    <button
      type="button"
      onClick={() => setLocale(next)}
      className={[
        'relative z-10 pointer-events-auto inline-flex items-center justify-center gap-2 pds-tag/60 text-ink/70 transition hover:bg-paper focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/60',
        size === 'sm' ? 'h-9 px-3 text-xs font-extrabold' : 'h-10 px-4 text-sm font-extrabold',
        className ?? '',
      ].join(' ')}
      aria-label={t('settings.language.title')}
      title={t('settings.language.title')}
    >
      <Languages className="h-4 w-4" aria-hidden="true" />
      <span>{label}</span>
    </button>
  )
}

